import React from 'react';
import { Section } from '@h2/types';
import { useConfigurationStore } from '../../stores/useConfigurationStore';
import { ConfigurationField } from './ConfigurationField';

interface ConfigurationSectionProps {
  section: Section;
  hideTitle?: boolean;
}

export const ConfigurationSection: React.FC<ConfigurationSectionProps> = ({ section, hideTitle = false }) => {
  const { formData } = useConfigurationStore();

  // 의존성 확인 함수
  const checkFieldDependency = (field: any) => {
    if (!field.dependency) return true;
    
    const dependentValue = formData[field.dependency.field];
    return dependentValue === field.dependency.value;
  };

  return (
    <div className="space-y-6">
      {section.fields.map((field) => {
        // 의존성이 충족되지 않으면 필드를 렌더링하지 않음
        if (!checkFieldDependency(field)) {
          return null;
        }

        return (
          <ConfigurationField
            key={field.id}
            field={field}
            section={section}
            hideTitle={hideTitle}
          />
        );
      })}
    </div>
  );
};
